<div class="container "
    [ngStyle]="{'background-color':(global.isMobile()||global.isDesktop() )? '#f9f9f9' : '#ffffff' }">
    <div class="closebutton pointer">
        <img (click)="closeDialog();global.gtmEvent('epk_popup','close')">
    </div>
    <div class="col-lg-6 px-0">
        <div class="content">
            <h1> Craft Your Musical Identity<br />
                <span>Build Your Songdew e-Press Kit</span>
            </h1>

            <p *ngIf="!global.isMobile() && !global.isTablet()">
                An Electronic Press Kit (e-Press Kit) functions as a music artist's professional profile.
                <br>
                <br>
                It's more than just a collection of your work; it's your story, your sound, and your identity all in one
                place.
                <br>
                <br>


                Imagine having your music journey and accolades seamlessly presented to industry professionals,
                promoters, and fans alike.
            </p>
            <img *ngIf=" global.isTablet() && !global.isMobile()" style="margin-left:-48px"
                src="../../../../assets/profileImageAndIcon/ipad.svg" alt="">
            <img *ngIf=" global.isMobile()" style="margin-left:-30px"
                src="../../../../assets/profileImageAndIcon/phone.svg" alt="">

            <div class=" d-flex justify-content-lg-start justify-content-center">
                <a class="button" routerLink="/{{user.slug}}"
                    (click)="  closeDialog();global.gtmEvent('epk_popup','build_epk')">Build Your
                    e-Press Kit</a>

            </div>
        </div>
    </div>
    <div class="col-lg-6 d-flex justify-content-end px-0" *ngIf="global.isDesktop()">
        <div id="nisha" style="position: relative; transform-style: preserve-3d;" data-tilt>



            <div class="flip-container">
                <div class="flipper">
                    <div class="front-1">
                        <img class=" img-fluid " src="../../../../assets/profileImageAndIcon/tab.svg">

                    </div>
                    <div class="back-1">
                        <img class=" img-fluid " style="height: 591px;"
                            src="../../../../assets/profileImageAndIcon/ipadback.png">

                    </div>
                </div>
            </div>





        </div>
    </div>
</div>
